class NewsList {
  constructor(newsListElement) {
    this.elem = newsListElement;
    this.init();
  }
  init() {
    this.initNewsPagination();
  }
  initNewsPagination() {
    const newsPagination = this.elem.querySelector('.pagination');
    if (!newsPagination) {
      return;
    }
    const paginationTriggers = newsPagination.querySelectorAll('.page-link');
    paginationTriggers.forEach(trigger => {
      trigger.addEventListener('click', async e => {
        e.preventDefault();
        const data = await this.getNews(e.currentTarget.href);
        this.updateNews(data);
      });
    });
  }
  async getNews(href) {
    const response = await fetch(href);
    const news = await response.text();
    return news;
  }
  updateNews(data) {
    if (!this.elem) {
      return;
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');
    const updatedNewsList = doc.querySelector('.news');
    if (updatedNewsList) {
      this.elem.innerHTML = updatedNewsList.innerHTML;
      // scroll window to top of the news list
      window.scrollTo({
        top: this.elem.offsetTop - 120,
        // 120px from the top of the news list as a buffer
        behavior: 'smooth'
      });
      this.initNewsPagination();
      window.dispatchEvent(new Event('resize'));
    }
  }
}
export default () => {
  // Find all news list elements on the page and instantiate a NewsList class for each
  const newsElements = document.querySelectorAll('.news');
  newsElements.forEach(newsElement => {
    new NewsList(newsElement);
  });
};